/*eslint no-script-url: 0 */
import React, { Component } from 'react';
import Constants from '../../Config/Config';
import $ from 'jquery';
import ReactPixel from 'react-facebook-pixel';
import Parser from 'html-react-parser';

const ajaxurl = Constants.URL.root+'/wp-admin/admin-ajax.php';

export default class CartForm extends Component {

	constructor(props) {
	    super(props);
		this.state = {
			buttonLoading: false
        }
	    this.submitForm = this.submitForm.bind(this);
  	}

  	submitForm = () => {
  		if (parseFloat(this.props.customizeQTY) > 0) {
  			window.location.href = Constants.URL.root+"/cart/";
  		} else {
  			this.setState({buttonLoading: true});
			const {cart1ItemTotal} = this.props;
  			$.ajax(ajaxurl, {
				method: "POST",
				dataType: 'json',
				data: $('.cartForm').serialize()+'&action=add_item_to_cart&cartTotal='+cart1ItemTotal,
				success: function (res) {
					window.location.href = Constants.URL.root+"/cart/";
					ReactPixel.track( 'AddToCart' );
				}
			});
  		}
	  }

	createWindowSizes = () => {
		const { matBoardWindowSize, matWindowValues, windowSizes } = this.props;
		let Windows = [];
		for (let i = 0; i < matBoardWindowSize; i++) {
			Windows.push(
				<div key={`WindowDimensionsPopUp-` + i}>
					<input type="hidden" name={`matWindowValues_width_` + (i + 1)} value={matWindowValues.getIn([i, 'width'])} />
					<input type="hidden" name={`matWindowValues_height_` + (i + 1)} value={matWindowValues.getIn([i, 'height'])} />
					<input type="hidden" name={`matWindowValues_left_` + (i + 1)} value={matWindowValues.getIn([i, 'left'])} />
					<input type="hidden" name={`matWindowValues_top_` + (i + 1)} value={matWindowValues.getIn([i, 'top'])} />
					<input type="hidden" name={`image_` + (i + 1)} value={windowSizes.getIn([i, 'uploadedFile'])} />
				</div>
			)
		}
		return Windows;
	}

	matPlauqeValues = () => {
		const { matPlauqeValues } = this.props;
		let plauqe = [];
		for (var i = 0; i < matPlauqeValues.size; i++) {
			plauqe.push(
				<div key={`plaques-` + i}>
					<input type="hidden" name={`matPlauqeValues_width`} value={matPlauqeValues.getIn([i, 'width'])} />
					<input type="hidden" name={`matPlauqeValues_height`} value={matPlauqeValues.getIn([i, 'height'])} />
					<input type="hidden" name={`matPlauqeValues_left`} value={matPlauqeValues.getIn([i, 'left'])} />
					<input type="hidden" name={`matPlauqeValues_top`} value={matPlauqeValues.getIn([i, 'top'])} />
					<input type="hidden" name={`matPlauqeValues_fill`} value={matPlauqeValues.getIn([i, 'fill'])} />
				</div>
			)
		}
		return plauqe;
	}

	matPlauqeValuesText = () => {
		const { plaqueValues } = this.props;
		let plaqueLines = [];
		for (var i = 0; i < plaqueValues.size; i++) {
			plaqueLines.push(
				<div key={`plaqueLines-` + i}>
					<input type="hidden" name={`matPlauqeValuesText_textAlign_` + (i + 1)} value={plaqueValues.getIn([i, 'align'])} />
					<input type="hidden" name={`matPlauqeValuesText_text_` + (i + 1)} value={plaqueValues.getIn([i, 'text'])} />
					<input type="hidden" name={`matPlauqeValuesText_fontSize_` + (i + 1)} value={plaqueValues.getIn([i, 'fontSize'])} />
					<input type="hidden" name={`matPlauqeValuesText_font_` + (i + 1)} value={plaqueValues.getIn([i, 'font'])} />
					<input type="hidden" name={`matPlauqeValuesText_fontWeight_` + (i + 1)} value={plaqueValues.getIn([i, 'bold']) ? 'Bold' : 'Normal'} />
					<input type="hidden" name={`matPlauqeValuesText_underline_` + (i + 1)} value={plaqueValues.getIn([i, 'underline']) ? 'Yes' : 'No'} />
					<input type="hidden" name={`matPlauqeValuesText_fontStyle_` + (i + 1)} value={plaqueValues.getIn([i, 'italic']) ? 'Italic' : 'Normal'} />
				</div>
			)
		}
		return plaqueLines;
	}

	render() {
		const { selectedmatBoard, selectedFrame, selectedTopMat, selectedMiddleMat, middleMatTotal, frameTotal, glassTotal, selectedGlassName, printTotal, selectedPrintName, selectedMatSize, frameSizeH, frameSizeW, canvasThumbImage, middleMatGapInCM, windowDimensionW, windowDimensionH, matBoardPrice, matBoardWindowSize, qty, plaqueValues} = this.props;

		return (
			<form action={Constants.URL.root+"/cart/"} method="post" className="cartForm">
				<input type="hidden" name="quantity" value={qty} />
				{selectedFrame.size > 0 &&
					<>
						<input type="hidden" name="frameTotal" value={frameTotal} />
						<input type="hidden" name="frameWidth" value={frameSizeW} />
						<input type="hidden" name="frameHeight" value={frameSizeH} />
						<input type="hidden" name="frame_id" value={selectedFrame.get('id')} />
					</>
				}
				<input type="hidden" name="matBoardPrice" value={matBoardPrice} />
				<input type="hidden" name="matBoardWindowSize" value={matBoardWindowSize} />
				{this.createWindowSizes()}
				{selectedmatBoard.get('has_plaque') === 'yes' && this.matPlauqeValues()}
				{selectedmatBoard.get('has_plaque') === 'yes' && this.matPlauqeValuesText()}
				{selectedmatBoard.get('has_plaque') === 'yes' && plaqueValues.size > 0 &&
					<input type="hidden" name="plaque_size" value={plaqueValues.size} />
				}
				<input type="hidden" name="matBoardWidth" value={windowDimensionW} />
				<input type="hidden" name="matBoardHeight" value={windowDimensionH} />
				<input type="hidden" name="item_id" value={selectedmatBoard.get('id')} />
				<input type="hidden" name="product_name" value={Parser(selectedmatBoard.get('name'))} />
				{canvasThumbImage !== null &&
					<input type="hidden" name="canvasImage" value={canvasThumbImage} />
				}
				{selectedTopMat.size > 0 &&
					<input type="hidden" name="tMatName" value={selectedTopMat.getIn(['title','rendered'])} />
				}
				{selectedMiddleMat.size > 0 && parseFloat(selectedMatSize) === 2 && parseFloat(middleMatGapInCM) > 0 &&
					<>
						<input type="hidden" name="mMatName" value={selectedMiddleMat.getIn(['title','rendered'])} />
						<input type="hidden" name="mMatTotal" value={middleMatTotal} />
						<input type="hidden" name="mMatVal" value={middleMatGapInCM} />
					</>
				}
				{selectedGlassName !== null &&
					<>
						<input type="hidden" name="glassName" value={selectedGlassName} />
						<input type="hidden" name="glassTotal" value={glassTotal} />
					</>
				}
				{selectedPrintName !== null &&
					<>
						<input type="hidden" name="printName" value={selectedPrintName} />
						<input type="hidden" name="printTotal" value={printTotal} />
					</>
				}
				<button type="button" className="btn btn-danger" onClick={this.submitForm}>
					{this.state.buttonLoading ?
						<div className="loading"></div> :
						<span>{this.props.btnText}</span>
					}
				</button>
			</form>
	    );
	}
}